import { takeEvery } from 'redux-saga/effects'
import { putPromise } from '../../../helpers/redux'
import * as actions from './actions'
import { listMemories } from './actions'

export function* refreshMemoriesAfterMutation() {
  yield takeEvery(
    [
      actions.ADD_MEMORY_SUCCESS,
      actions.UPDATE_MEMORY_SUCCESS,
      actions.DELETE_MEMORY_SUCCESS,
      actions.RESOLVE_MEMORY_FLAGS_SUCCESS,
    ],
    function* () {
      yield putPromise(listMemories())
    },
  )
}
